import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {ButtonInfo} from 'components/buttons';

const ARROW_WIDTH = 35;
const VIEWPORT_PADDING = 16;

const getDropStyle = (iconRect, tooltipWidth) => {
  const viewport = document.documentElement.clientWidth || window.innerWidth;
  const iconViewportLeft = iconRect.left;
  const iconViewportCenter = iconRect.left + iconRect.width / 2;
  const halfTooltip = tooltipWidth / 2;

  let tooltipViewportLeft = iconViewportCenter - halfTooltip;
  const tooltipViewportRight = tooltipViewportLeft + tooltipWidth;
  const rightOverflow = tooltipViewportRight - (viewport - VIEWPORT_PADDING);
  const leftOverflow = VIEWPORT_PADDING - tooltipViewportLeft;
  if (rightOverflow > 0) tooltipViewportLeft -= rightOverflow;
  else if (leftOverflow > 0) tooltipViewportLeft += leftOverflow;

  const tooltipLeftLocal = tooltipViewportLeft - iconViewportLeft;
  const arrowCenterInTooltip = iconViewportCenter - tooltipViewportLeft;
  const arrowLeftInTooltip = arrowCenterInTooltip - ARROW_WIDTH / 2;

  return {
    '--drop-tooltip-left': `${tooltipLeftLocal}px`,
    '--drop-arrow-left': `${arrowLeftInTooltip}px`
  };
};

const InfoTooltip = ({content, iconClassName, tooltipClassName}) => {
  const iconRef = useRef(null);
  const tooltipRef = useRef(null);
  const [dropStyle, setDropStyle] = useState(null);

  useEffect(() => {
    const compute = () => {
      if (!iconRef.current || !tooltipRef.current) return;
      setDropStyle(
        getDropStyle(
          iconRef.current.getBoundingClientRect(),
          tooltipRef.current.offsetWidth
        )
      );
    };
    compute();
    window.addEventListener('resize', compute);
    return () => window.removeEventListener('resize', compute);
  }, []);

  return (
    <ButtonInfo ref={iconRef} className={cn(iconClassName, 'ButtonInfoDrop')}>
      <div
        ref={tooltipRef}
        className={cn(
          'DropInfo pointer-events-none DropInfoDynamic',
          tooltipClassName
        )}
        style={dropStyle || undefined}
      >
        {content}
      </div>
    </ButtonInfo>
  );
};

InfoTooltip.propTypes = {
  content: PropTypes.node.isRequired,
  iconClassName: PropTypes.string,
  tooltipClassName: PropTypes.string
};

InfoTooltip.defaultProps = {
  iconClassName: 'GrayOutline',
  tooltipClassName: 'Small'
};

export default InfoTooltip;
